export default __webpack_public_path__ + "static/media/logoPrinterConnect.5105c1e9.png";